import { DepartmentsEnum } from '@moonpig/web-shared-types-graphql'
import { ApplicableFilter, FilterItem } from '../../services/types/services'

const filterOrderByDepartment: Record<
  | DepartmentsEnum.ALL_CARDS
  | DepartmentsEnum.ALL_GIFTS
  | DepartmentsEnum.ALL_FLOWERS_AND_PLANTS,
  string[]
> = {
  [DepartmentsEnum.ALL_CARDS]: [
    'whos-it-for',
    'newia-occasion',
    'photo-upload-count-group',
    'integer-birthday milestones',
    'birthday-milestones',
    'newia-age',
    'photo-cards',
    'not-rude',
  ],
  [DepartmentsEnum.ALL_GIFTS]: [
    'product-type',
    'whos-it-for',
    'newia-occasion',
    'newia-age',
    'price',
    'personalisable',
  ],
  [DepartmentsEnum.ALL_FLOWERS_AND_PLANTS]: [
    'newia-occasion',
    'price',
    'newia-gift-sets-hampers-letterbox',
  ],
}

export const orderQuickFilters = (
  filters: FilterItem[],
  department: DepartmentsEnum,
) => {
  const order =
    filterOrderByDepartment[
      department as keyof typeof filterOrderByDepartment
    ] || /* istanbul ignore next */ []

  const filterToReturn = (
    filters.filter(
      f =>
        (f.__typename === 'FilterCategory' ||
          f.__typename === 'FilterToggle' ||
          f.__typename === 'FilterInvertedToggle' ||
          f.__typename === 'IntegerFilter') &&
        f.isQuickFilter &&
        order.includes(f.id),
    ) as ApplicableFilter[]
  ).sort((a, b) => {
    return order.indexOf(a.id) - order.indexOf(b.id)
  })

  return filterToReturn
}
